import Api from "./api";
import { encryptData, decryptData } from '../services/crypto';
import CryptoJS from 'crypto-js';
import axios from 'axios';

export const user = async (data: any) => {
    const api = new Api();
    let encryptedResponse = await api.post("user", data);
    if(encryptedResponse?.success) {
        const decryptedData = await decryptData(encryptedResponse?.success?.data);
        encryptedResponse.success['data'] = JSON.parse(decryptedData);
        return encryptedResponse;
    }  else {
        return encryptedResponse;
    }
}

export const sendOtp = async (data: any) => {
    const api = new Api();
    const encryptedData:any = await encryptData(JSON.stringify(data));
    const response = await api.post("otp/send", encryptedData);
    if(response.success) {
        sessionStorage.setItem("otp_id", response?.success?.data?.otp_id);
    }
    return response;
}

export const verifyOtp = async (data: any) => {
    const api = new Api();
    const otp_id = await sessionStorage.getItem("otp_id");
    data['otpId'] = otp_id;
    const encryptedData:any = await encryptData(JSON.stringify(data));
    const encryptedResponse = await api.post("otp/verify", encryptedData);
    if(encryptedResponse.success || encryptedResponse.error) {
        return encryptedData;
    }
    return JSON.parse(await decryptData(encryptedResponse));
}

export const dwsLogin = async (data: any) => {
    var url = process.env.REACT_APP_LOGIN_URL;
    let encryptedBody = await CryptoJS.AES.encrypt(JSON.stringify(data), 'Data!abs@uth84$').toString(); 
    let decryptedBody = CryptoJS.AES.decrypt(encryptedBody, 'Data!abs@uth84$').toString(CryptoJS.enc.Utf8);
    return await axios.post(url || "", {data: encryptedBody}).then((response: any) => {
        localStorage.setItem('token', response?.data?.success?.data?.token);
        return response.data;
    }).catch((error: any) => {
        console.log(error);
    });
}
